import { queryOptions, useQuery } from '@tanstack/react-query';
import { type NotificationSettings, notificationSettingsScheme } from '@/models/mine/notification-setting';
import { generateResponseScheme, type RespondedWith } from '@/models/response';
import { useIsAuthenticated } from '@/stores/auth';
import { fetcher } from '@/utils/fetcher';

export const notificationSettingsQueryOptions = queryOptions({
  queryKey: ['/GetNotificationSettings'],
  queryFn: ({ signal }) =>
    fetcher<RespondedWith<NotificationSettings>>('/GetNotificationSettings', undefined, {
      signal,
      schema: generateResponseScheme(notificationSettingsScheme),
      validResponseCodes: [0],
    }).then((response) => response?.Data ?? null),
});

export default function useNotificationSettings() {
  const isAuthenticated = useIsAuthenticated();

  return useQuery({ ...notificationSettingsQueryOptions, enabled: isAuthenticated });
}
